import { VITE_MOCK_API, VITE_CASE_DATA_API, VITE_USE_MOCK } from 'Constants/appEnvConstants'

export default function getDocumentsBaseUrl() {
  // eslint-disable-next-line no-undef
  return JSON.parse(VITE_USE_MOCK) ? VITE_MOCK_API : VITE_CASE_DATA_API;
}
